export function getPageSizeOptions(numberOfRows: number): number[] {
  // return [5, 10, 50, 100];
  if (numberOfRows <= 50) {
    return [50];
  } else if (numberOfRows > 50 && numberOfRows <= 100) {
    return [50, 100];
  } else if (numberOfRows > 100 && numberOfRows <= 500) {
    return [50, 100, 500];
  } else if (numberOfRows > 500 && numberOfRows <= 1000) {
    return [50, 100, 500, 1000];
  } else if (numberOfRows > 1000 && numberOfRows <= 5000) {
    return [50, 100, 500, 1000, 5000];
  } else {
    return [50, 100, 500, 1000, 5000, 10000];
  }
}

export const defaultPageSize = 50;
